
import React, { useState, useCallback } from 'react';
import { InternationalizationContext } from './InternationalizationContext';
import { IntlProvider } from 'react-intl';
import flatten from 'flat';
import { messages } from '../../translations/messages';
import { LANGUAGES } from '../../translations/languages';
import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/de';

export const InternationalizationProvider = ({
  children,
}) => {
  /**
   * Determines if the provided locale is supported by
   * our pltatform.
   */
  const isLocaleSupported = useCallback(
    value => {
      return Object.keys(LANGUAGES).some(
        langKey => LANGUAGES[langKey] === value
      );
    },
    []
  );

  const storedLanguage = window.localStorage.getItem('lang');
  // Fallback to "it" if there is not a valid stored language.
  const initialLanguage = isLocaleSupported(storedLanguage) ? storedLanguage : LANGUAGES.IT;

  // State embedding the current "locale".
  const [locale, setLocale] = useState(initialLanguage);
  moment.locale(initialLanguage);

  /**
   * Changes the locale.
   */
  const changeLocale = value => {
    // Do nothing if the locale is not supported.
    if (!isLocaleSupported(value)) {
      return;
    }
    window.localStorage.setItem('lang', value);
    moment.locale(value);
    setLocale(value);
  };

  // Flatten the message of the given locale.
  const flattenIntlMessages = flatten(messages[locale]);

  return (
    <InternationalizationContext.Provider value={{ locale, changeLocale }}>
      <IntlProvider locale={locale} messages={flattenIntlMessages}>
        {children}
      </IntlProvider>
    </InternationalizationContext.Provider>
  );
};